import { render } from "./Recommendations.vue?vue&type=template&id=4a5a4fad&scoped=true"
import script from "./Recommendations.vue?vue&type=script&lang=js"
export * from "./Recommendations.vue?vue&type=script&lang=js"

import "./Recommendations.vue?vue&type=style&index=0&id=4a5a4fad&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5a4fad"]])

export default __exports__